import client from '@/utils/axios';
import {
  ComparatorPartner,
  PropfirmOfferKey,
  PropfirmOfferOverride,
} from '@/service/propfirm-offer/propfirm-offer-types';

export class PropfirmOfferService {
  static async overrides(): Promise<PropfirmOfferOverride[]> {
    const res = await client.get<PropfirmOfferOverride[]>(
      '/propfirm-offer/overrides',
    );
    return res.data;
  }

  static async save(
    override: PropfirmOfferOverride,
  ): Promise<PropfirmOfferOverride> {
    const res = await client.put<PropfirmOfferOverride>(
      '/propfirm-offer/overrides',
      override,
    );
    return res.data;
  }

  static async reset(key: PropfirmOfferKey): Promise<void> {
    await client.delete('/propfirm-offer/overrides', { params: key });
  }

  static async partners(): Promise<ComparatorPartner[]> {
    const res = await client.get<ComparatorPartner[]>(
      '/propfirm-offer/partners',
    );
    return res.data;
  }

  /// `null` quand l'enseigne, vidée, n'est plus partenaire.
  static async savePartner(
    partner: ComparatorPartner,
  ): Promise<ComparatorPartner | null> {
    const res = await client.put<ComparatorPartner | null>(
      '/propfirm-offer/partners',
      partner,
    );
    return res.data;
  }

  static async resetPartner(slug: string): Promise<void> {
    await client.delete('/propfirm-offer/partners', { params: { slug } });
  }
}
